import React, { useState, useRef } from 'react';
import axios from 'axios';
import './SpinToWinNew.css';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import classNames from 'classnames';
import Input from '@material-ui/core/Input';
import Footer from 'HLASReactComponents/layouts/Footer';
import { ViewArray, ViewArrayOutlined } from '@material-ui/icons';
import { clearerror } from 'modules/prestige/redux/actions';
import Helmet from "react-helmet";

// wheelData with prize id option, 0 being thank you for spinning
const wheelData = [
  { option: 2 },
  { option: 7 },
  { option: 1 },
  { option: 3 },
  { option: 6 },
  { option: 4 },
  { option: 5 },
  { option: 0 } 
];

// Prize message mapping for result modal (matches your image)
const prizeMessages = {
  1: (
    <span>
      Congratulations!<br />
      You have won <b>160 KrisFlyer Miles!</b>
    </span>
  ),
  2: (
    <span>
      Congratulations!<br />
      You have won <b>600 KrisFlyer Miles!</b>
    </span>
  ),
  3: (
    <span>
      Congratulations!<br />
      You have won a <b>$2 CDG Zig</b> voucher code!
    </span>
  ),
  4: (
    <span>
      Congratulations!<br />
      Enjoy <b>$6 off</b> your next <b>HLAS Travel Insurance</b> plan!
    </span>
  ),
  5: (
    <span>
      <b>JACKPOT!</b><br />
      You’ve earned <b>60 more entries</b> in the Grand Draw!
    </span>
  ),
  6: (
    <span>
      Congratulations!<br />
      You’ve earned <b>6 more entries</b> to win in the Grand Draw!
    </span>
  ),
  7: (
    <span>
      Congratulations!<br />
      You’ve earned <b>1 extra Grand Draw entry!</b>
    </span>
  ),
};

function SpinToWinNew() {
  const [step, setStep] = useState('pageload');
  const [prize, setPrize] = useState(null);
  const [form, setForm] = useState({ surname: '', given_name: '', email: '', contact: '' });
  const [prizeWonId, setPrizeWonId] = useState(null);
  const [error, setError] = useState('');
  const [spinning, setSpinning] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [prizeIndex, setPrizeIndex] = useState(0);
  const wheelRef = useRef();

  // Calculate the angle per prize
  const anglePerPrize = 360 / wheelData.length;

  const handleSpinNow = async () => {
    setStep('spin');
  }

  const clearError = async () => {
    setError('');
  }

  // 1. Spin the wheel (animated)
  const handleSpin = async () => {
    setError('');
    setSpinning(true);

    try {
      const res = await axios.post(process.env.REACT_APP_API_GATEWAY_URL + '/api/spin-to-win-new/spin');
      console.log(res.data.prize);
      const prizeId = res.data.prize.id;
      setPrize(res.data.prize);

      // Find the index of the prize in wheelData
      const idx = wheelData.findIndex(
        (item) => item.option === prizeId
      );

      // Calculate random spins (e.g., 5 full spins) + angle to land on prize
      const spins = 5;
      const finalAngle = (360 * spins - (idx * anglePerPrize) - anglePerPrize / 2) + 22.5;
      setRotation(finalAngle);

      // Wait for animation to finish (duration must match CSS)
      setTimeout(() => {
        setStep('result');
        setSpinning(false);
      }, 3500); // 3.5s animation
    } catch (err) {
      setError(err.response?.data?.error || 'Spin failed');
      setSpinning(false);
    }
  };

  // 3. After spin, show prize and ask to spin again or proceed
  const handleSpinAgain = () => {
    setPrize(null);
    setStep('spin');
    setRotation(0);
  };
  const handleProceed = () => setStep('form');

  // 4. Show form (add KrisFlyer Number if needed)
  const handleFormChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const checkboxRef = useRef<HTMLInputElement>(null);
  // 5. Submit form
  const handleSubmitForm = async e => {
    e.preventDefault();
    setError('');
    var contactNumber = document.forms['stwForm']['contact'].value;
    if (contactNumber.length != 8) {
      alert("Please enter your 8-digit mobile number");
      return false;
    }
    var email = document.forms['stwForm']['email'].value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if(!emailRegex.test(email)) {
      alert("Please enter a valid email address");
      return false;
    }
    let result = window.confirm("Do you want to proceed to submit this info?");
    if (result) {
      try {
        setSubmitting(true);
        const res = await axios.post(process.env.REACT_APP_API_GATEWAY_URL + '/api/spin-to-win-new/submit-form', { ...form, prize_id: prize.id });
        setPrizeWonId(res.data.prize_won_id);
        setStep('done');
      } catch (err) {
        const msg = err.response?.data?.error || 'Submission failed';
        if (msg.toLowerCase().includes('already submitted')) {
          setStep('submissionLimitReached');
        } else {
          setError(msg);
        }
      }
    }
  };

  const handleBackToWebsite = async e => {
    window.location.href = "https://www.hlas.com.sg";
  }


  // 7. Render
  return (
    <React.Fragment>
      <header className='headerStw'>
        <div>
            <a href="https://www.hlas.com.sg/">
              <img alt="Hong Leong group | HL Assurance" className="t-logo-120" src="https://assets.hlas.com.sg/common/hlas_logo.png" />
            </a>
          </div>
      </header>
      <div className="spin-to-win-container">
        {step === 'pageload' && (
            <Dialog className={classNames("hlasmodal")} open={true}>
              <DialogContent className={classNames("hlasmodalwhite-content")}>
                <div className="popup-section">
                  <img
                    className='popup-image'
                    src="https://www.hlas.com.sg/wp-content/uploads/2025/07/Spin-To-Win-Microsite-Popup-min-23Jul2025.png"
                  />
                  <p style={{ borderRadius: '32px' }}>
                    From <b>22 July to 3 September 2025,</b> every policy you buy on HL Assurance website gives you a chance to win <b>60,000 KrisFlyer Miles</b> in our Grand Draw. Every $10 of premium = 1 entry to win the big prize!
                    <br />
                    <br />
                    Plus, spin the wheel for instant prizes and add us on WhatsApp to get your rewards! 
                  </p>
                  <button className="start-popup-btn" onClick={handleSpinNow}>SPIN NOW</button>
                </div>
              </DialogContent>
            </Dialog>)
        }
        <div className="spin-to-win-content">
          <img className="spin-content-bg" src="https://www.hlas.com.sg/wp-content/uploads/2025/07/Spin-To-Win-Microsite-Bgrd-min-23Jul2025.png" />
          <div className="spin-section">
            <div className="wheel-graphic">
              {/* Pointer on top, upside down */}
              <img
                src="https://assets.hlas.com.sg/spintowinnew/Pointer.png"
                alt="Pointer"
                className="custom-pointer"
              />
              <img
                ref={wheelRef}
                src="https://assets.hlas.com.sg/spintowinnew/wheel.png"
                alt="Wheel"
                className="custom-wheel"
                style={{
                  transition: spinning ? 'transform 3.5s cubic-bezier(0.33,1,0.68,1)' : 'none',
                  transform: `rotate(${rotation}deg)`
                }}
              />
              <div className="footer">
                <a target="_blank" href="https://www.hlas.com.sg/wp-content/uploads/2025/07/HLAS_Spin_and_Win_FAQs.pdf">Frequently Asked Questions</a>
                <a target="_blank" href="https://www.hlas.com.sg/wp-content/uploads/2025/07/HLAS_Spin_and_Win_Terms_and_Conditions.pdf">Terms and Conditions</a>
              </div>
              <button className="spin-btn" onClick={handleSpin} disabled={spinning}>
                {spinning ? 'SPINNING...' : 'SPIN NOW'}
              </button>
            </div>
          </div>
          {step === 'result' && (
            <Dialog className={classNames("hlasmodal")} open={true}>
              <DialogContent className={classNames("hlasmodal-content")}>
                <div className="result-section">
                  <h3 style={{ borderRadius: '32px' }}>
                    {prize && prizeMessages[prize.id]
                      ? prizeMessages[prize.id]
                      : <></>
                    }
                  </h3>
                  <button className="modal-btn" onClick={handleSpinAgain}>SPIN AGAIN</button>
                  <button className="modal-btn" onClick={handleProceed}>CLAIM YOUR PRIZE</button>
                </div>
              </DialogContent>
            </Dialog>
          )}
          {step === 'form' && (
            <Dialog className={classNames("hlasmodal")} open={true}>
              <DialogContent className={classNames("hlasmodal-content")}>
                <div className="form-section">
                  <form name="stwForm" className="spin-form" onSubmit={handleSubmitForm}>
                    <p style={{ fontWeight: 'bold' }}>To claim your prize*:</p>
                    <ol>
                      <li>Submit your details below</li>
                      <li>Purchase any insurance plan by 11:59PM today on our website </li>
                      <li>Details submitted must match your purchased plan's details</li>
                    </ol>    
                    <p>
                      We will send your prize redemption via WhatsApp on next business day
                    </p>
                    <label style={{ fontWeight: 'bold', fontSize: '0.83em' }}>
                      *Limited to 1 submission per day per customer.
                    </label>
                    <br/>
                    <Input name="surname" className="stw-input" value={form.surname} onChange={handleFormChange} placeholder="Surname" required />
                    <Input name="given_name" className="stw-input" value={form.given_name} onChange={handleFormChange} placeholder="Given Name" required />
                    <Input name="email" className="stw-input" value={form.email} onChange={handleFormChange} placeholder="Email" required />
                    <Input name="contact" className="stw-input" value={form.contact} onChange={handleFormChange} placeholder="Mobile Number" required />
                    <h5 style={{textAlign: "left", fontWeight: "normal", margin: "10px 0"}}>By submitting this form, I confirm and agree to the <a target="_blank" style={{ color: "#fff" }} href="https://www.hlas.com.sg/wp-content/uploads/2025/07/HLAS_Spin_and_Win_Terms_and_Conditions.pdf">Terms & Conditions</a>.</h5>
                    <div className="form-terms">
                      <Input 
                        oninvalid="this.setCustomValidity('Please check this box to proceed.')"
                        oninput="this.setCustomValidity('')" 
                        type="checkbox" 
                        id="agree" 
                        required />
                      <label for="agree" >By providing your contact details, you consent to receiving information about our latest promotions and product updates from Hong Leong Group.</label>
                    </div>
                    <button className="modal-btn" type="submit" disabled={submitting}>{submitting ? 'SUBMITTING...': 'SUBMIT' }</button>
                  </form>
                </div>
              </DialogContent>
            </Dialog>
          )}
          {step === 'done' && (
            <Dialog className={classNames("hlasmodal")} open={true}>
              <DialogContent className={classNames("hlasmodal-content")}>
                <div className="done-section">
                  <h3>You’re all set! Thanks for spinning with us!</h3>
                  <p>Make your purchase today and enjoy peace of mind with HL Assurance.</p>
                  <button className="modal-btn" type="button" onClick={handleBackToWebsite}>BROWSE HLAS PROTECTION PLANS</button>
                </div>
              </DialogContent>
            </Dialog>
          )}
          {step === 'submissionLimitReached' && (
            <Dialog className={classNames("hlasmodal")} open={true}>
              <DialogContent className={classNames("hlasmodal-content")}>
                <div className="done-section" style={{ textAlign: 'center', background: '#f22c0d', color: '#fff', borderRadius: 32, padding: 32 }}>
                  <h3 style={{ fontWeight: 'bold', marginBottom: 16 }}>Thanks for your enthusiasm!</h3>
                  <p style={{ marginBottom: 24 }}>
                    You’ve reached today’s submission limit. Please try again tomorrow.
                  </p>
                  <button
                    className="modal-btn"
                    style={{ background: '#002b5c', color: '#fff', fontWeight: 'bold', borderRadius: 8, padding: '12px 24px', fontSize: 16 }}
                    onClick={handleBackToWebsite}
                  >
                    BROWSE HLAS PROTECTION PLANS
                  </button>
                </div>
              </DialogContent>
            </Dialog>
          )}
          {error && (
            <Dialog className={classNames("hlasmodal")} open={true}>
              <DialogContent className={classNames("hlasmodal-content")}>
                  <div className="result-section">
                    <p style={{ borderRadius: '32px' }}>
                      {error}
                    </p>
                    <button className="modal-btn" onClick={clearError}>OK</button>
                  </div>
              </DialogContent>
            </Dialog>
          )}
        </div>
      </div>
      <footer className='footerStw'>
        <div className="left">
          <a href="https://www.hlas.com.sg/">
            <img alt="Hong Leong group | HL Assurance" className="t-logo-120" src="https://assets.hlas.com.sg/common/hlas_logo.png" />
          </a>
        </div>
        <div className="right">
          <ul>
            <li><a href="https://www.hlas.com.sg/policyonpersonaldata/">Policy on Personal Data</a></li>
            <li> | </li>
            <li><a href="https://www.hlas.com.sg/hlassurancesitemap/">Site Map</a></li>
            <li> | </li>
            <li><a href="https://www.hlas.com.sg/termsandconditions/">Terms and Conditions</a></li>
            <li> | </li>
            <li><a href="https://www.hlas.com.sg/onlinesecurity/">Online Security</a></li>
          </ul>
          <p>Copyright © 2025 HL Assurance<br />
            This site is best viewed with Google Chrome, Firefox, Internet Explorer 10.x or above.
          </p>
        </div>
      </footer>
    </React.Fragment>
  );
}

export default SpinToWinNew;